import { render, staticRenderFns } from "./SyncEdit.vue?vue&type=template&id=12e4a9c0&scoped=true"
import script from "./SyncEdit.vue?vue&type=script&lang=ts"
export * from "./SyncEdit.vue?vue&type=script&lang=ts"
import style0 from "./SyncEdit.vue?vue&type=style&index=0&id=12e4a9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4a9c0",
  null
  
)

export default component.exports